<template>
  <div :class="isShow?'home noscroll':'home'">
    <header class="header">
      <div class="container">
        <h1 class="logo">
          <a href="">
            <img src="../../assets/images/home_logo.png" alt="" />
          </a>
        </h1>
        <div class="nav">
          <a href="/login">登录</a><span>|</span><a href="#contact">合作咨询</a>
        </div>
      </div>
    </header>
    <main class="main">
      <section class="section-1">
        <div class="container container-1">
          <div class="text">
            <h3>变色龙智能创意平台</h3>
            <h5>一站式创意解决方案平台</h5>
            <p>
              优质创意智能生成，创意数据全方位监测，助力提升营销效果<br />
              强大的编辑能力，操作便捷高效，一键即可生成千人千面的创意
            </p>
            <div>
              <a href="#contact" class="btn">合作咨询</a>
              <a @click="show" class="btn">查看 Demo</a>
            </div>
          </div>
          <div class="layer">
            <layer-svg></layer-svg>
          </div>
        </div>
      </section>
      <section class="section-2">
        <div class="container">
          <img src="../../assets/images/home/section_bg_2.png" alt="" />
          <h2 class="title">
            图片创意
          </h2>
          <div class="content content-1">
            <h3>海量模板</h3>
            <p>拥有海量的广告创意模板</p>
            <p>覆盖多行业</p>
          </div>
          <div class="content content-2">
            <h3>操作简单</h3>
            <p>利用模板，简单编辑</p>
            <p>即可生成属于自己创意</p>
          </div>
          <div class="content content-3">
            <h3>批量生成</h3>
            <p>快速生成海量的</p>
            <p>千人千面的创意</p>
          </div>
        </div>
      </section>
      <section class="section-3">
        <div class="container">
          <img src="../../assets/images/home/section_bg_3.png" alt="" />
          <h3 class="title">视频创意</h3>
          <p class="content-1">
            相比图片创意，视频可以承载更多的信息，向用户传达更多的内容，从而能够提升转化
          </p>
          <p class="content-2">
            我们拥有大量的视频模板，只需简单几步操作，即可快速生成自己的商品视频广告。支持在线实时生成，智能生成动态视频创意。
          </p>
        </div>
      </section>
      <section id="contact" class="section-4">
        <div class="container">
          <img src="../../assets/images/home/section_bg_4.png" alt="" />
          <div class="content content-1">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-phone"></use>
            </svg>
            <div>
              <p>联系电话</p>
              <p>400-1520-118</p>
            </div>
          </div>
          <div class="content content-2">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-email"></use>
            </svg>
            <div>
              <p>商务合作</p>
              <p>business@fancydigital.com.cn</p>
            </div>
          </div>
          <div class="content content-3">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-address"></use>
            </svg>
            <div>
              <p>公司地址</p>
              <p>北京：海淀区苏州街3号大恒科技大厦北座9层</p>
              <p>上海：浦东新区秋月路26号矽岸国际4幢3楼</p>
              <p>广州：天河区珠江新城珠江西路高德置地夏广场D座703室</p>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer class="footer">
      <p class="copyright">
        Copyright©FancyDigital.All Rights reserved.<br />
        京ICP备15031715号-2
      </p>
    </footer>
    <div class="dialog" v-if="isShow">
      <i class="el-icon-close close" @click="close"></i>
      <h3>智能创意尺寸适配演示</h3>
      <p>用鼠标拖动边框，自动适配各种尺寸</p>
      <template-drag />
    </div>
  </div>
</template>
<script>
import LayerSvg from './Svg';
import TemplateDrag from 'components/TemplateDrag';

export default {
  name: 'home',
  components: {
    'layer-svg': LayerSvg,
    'template-drag': TemplateDrag
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    close(){
      this.isShow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './index.scss/';
</style>
